export const FETCH_APPLICATION_LOADING = "FETCH_APPLICATION_LOADING";
export const FETCH_APPLICATION = "FETCH_APPLICATION";
export const FETCH_HEADER_LOADING = "FETCH_HEADER_LOADING";
export const FETCH_HEADER = "FETCH_HEADER";
export const SERIES_DATA = "SERIES_DATA";
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
